// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28FS5","delete":"styles_delete__30W1g","update":"styles_update__3miQJ","add":"styles_add__bMZ3G"};